<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h3 class="panel-title">
        Revenue by Location
        <CalculationTooltip text="Completed-order revenue at each location, with the comparison period alongside." />
      </h3>
    </div>
    <div class="panel-body">
      <BarChart v-if="chartData" :key="chartKey" :data="chartData" :options="chartOptions" />
      <p v-else class="text-muted">No locations selected.</p>
    </div>
  </div>
</template>

<script>
import { Bar as BarChart } from 'vue-chartjs';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import CalculationTooltip from '../../scheduling-dashboard/components/CalculationTooltip.vue';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default {
  name: 'RevenueBySchoolChart',
  components: { BarChart, CalculationTooltip },
  props: {
    bySchool: { type: Array, required: true }
  },
  data: function() {
    return {
      chartKey: 0
    };
  },
  watch: {
    bySchool: function() {
      this.chartKey++;
    }
  },
  computed: {
    chartData() {
      if (!this.bySchool || this.bySchool.length === 0) return null;
      return {
        labels: this.bySchool.map(function(row) { return row.school_name; }),
        datasets: [
          {
            label: 'Revenue',
            data: this.bySchool.map(function(row) { return row.total_revenue / 100; }),
            backgroundColor: '#337ab7'
          },
          {
            label: 'Previous Period',
            data: this.bySchool.map(function(row) { return row.previous_total_revenue / 100; }),
            backgroundColor: '#bbb'
          }
        ]
      };
    },
    chartOptions() {
      return {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: { position: 'top' },
          tooltip: {
            callbacks: {
              label: function(context) {
                return context.dataset.label + ': $' + context.parsed.x.toLocaleString();
              }
            }
          }
        },
        scales: {
          x: {
            beginAtZero: true,
            ticks: {
              callback: function(value) {
                return '$' + value.toLocaleString();
              }
            }
          }
        }
      };
    }
  }
};
</script>
